import ArrowDownIcon from '@grnhse/seedling/lib/birch/icons/arrow_down';
import ArrowUpIcon from '@grnhse/seedling/lib/birch/icons/arrow_up';
import { Grid } from '@grnhse/seedling/lib/birch/layouts/grid';
import {
  SectionTitle,
  SecondaryBody,
} from '@grnhse/seedling/lib/birch/typography';
import React from 'react';
import styled from 'styled-components';
import { HelpTooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import Tokens from '@grnhse/seedling/lib/birch/tokens';
import { DotBadge } from 'candidate_profile_redesign/shared/badge';

type CollapsibleTitleProps = {
  isOpen: boolean;
  toggleIsOpen: () => void;
  title: string;
  subtitle?: string;
  renderTooltip?: boolean;
  tooltipLabel?: string;
  unread?: boolean;
  [key: string]: any;
};

const CollapsibleTitle = ({
  isOpen,
  toggleIsOpen,
  title,
  subtitle,
  renderTooltip = false,
  tooltipLabel = '',
  unread = false,
  ...props
}: CollapsibleTitleProps) => {
  return (
    <Clickable
      {...props}
      style={{
        paddingLeft: Tokens.spacing['3'],
        paddingRight: Tokens.spacing['3'],
        paddingBottom: isOpen ? Tokens.spacing['2'] : 0,
      }}
      onClick={toggleIsOpen}
      type="button"
      disabled={renderTooltip}
      data-provides={`collapsible-title-${title
        .toLowerCase()
        .replace(/\s+/g, '-')}`}
    >
      <StyledGridItem item>
        <Grid container direction="column" spacing={0}>
          <Grid container alignItems="center" spacing={0}>
            <SectionTitle>{title}</SectionTitle>
            {renderTooltip && (
              <HelpTooltip label={tooltipLabel} ariaLabel={tooltipLabel} />
            )}
            {unread && <DotBadge />}
          </Grid>
          {subtitle && <SecondaryBody metadata>{subtitle}</SecondaryBody>}
        </Grid>
      </StyledGridItem>
      <Grid item>
        {isOpen ? (
          <ArrowUpIcon size="sm" />
        ) : (
          <ArrowDownIcon
            size="sm"
            color={
              renderTooltip ? FullPalette.GREY_700 : FullPalette.EVERGREEN_700
            }
          />
        )}
      </Grid>
    </Clickable>
  );
};

const StyledGridItem = styled(Grid)`
  display: flex;
  align-items: flex-start;
  gap: ${Tokens.spacing['1']};
`;

const Clickable = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default CollapsibleTitle;
